import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { DeviceRecord, DevicesState } from '@/types/log.types';

const initialState: DevicesState = {
  list: [],
  totalCount: 0,
  loading: false,
  error: null,
};

const devicesSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {
    fetchDevicesRequest(state, _action: PayloadAction<{ page: number; limit: number; search?: string; sortField?: string; sortOrder?: string }>) {
      state.loading = true; state.error = null;
    },
    fetchDevicesSuccess(state, action: PayloadAction<{ list: DeviceRecord[]; totalCount: number }>) {
      state.loading = false; state.list = action.payload.list; state.totalCount = action.payload.totalCount;
    },
    fetchDevicesFailure(state, action: PayloadAction<string>) {
      state.loading = false; state.error = action.payload;
    },
  },
});

export const {
  fetchDevicesRequest, fetchDevicesSuccess, fetchDevicesFailure,
} = devicesSlice.actions;
export default devicesSlice.reducer;
